module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selection"
  }, [_c('button', {
    class: _vm.selectedProductType === 'wildcard' ? 'selected' : '',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeTypeTo('wildcard')
      }
    }
  }, [_vm._v("\n    Wildcard\n  ")]), _vm._v(" "), _c('button', {
    class: _vm.selectedProductType === 'adoption' ? 'selected' : '',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeTypeTo('adoption')
      }
    }
  }, [_vm._v("\n    Adopt\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-051d9e96","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=csplt5ikear!./~/string-replace-webpack-plugin/loader.js?id=ja005zozwkc!./src/components/ecommerce/filter/ProductType.vue
// module id = 636
// module chunks = 0